import axios from "axios";
//check if url is local or production
const isLocalhost = false;
// window.location.hostname === "localhost" ||
// window.location.hostname.startsWith("127.");
const axiosToken = axios.create({
  baseURL: isLocalhost
    ? process.env.REACT_APP_SOCIAL_WALLET_API_LOCAL
    : process.env.REACT_APP_SOCIAL_WALLET_API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to add the authorization header

let currentInterceptor = null;

export function setAxiosToken(token) {
  // Eject the previous interceptor to avoid stacking stale tokens
  if (currentInterceptor !== null) {
    axiosToken.interceptors.request.eject(currentInterceptor);
  }

  currentInterceptor = axiosToken.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["x-api-key"] = process.env.REACT_APP_HORUS_API_KEY;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export default axiosToken;
